import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SettingsService } from '@services/settings.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-directions-overlay',
  templateUrl: './directions-overlay.component.html',
  styleUrls: ['./directions-overlay.component.scss'],
})
export class DirectionsOverlayComponent {
  public config: Observable<string[]> = this.getConfig();

  constructor(
    public dialogRef: MatDialogRef<DirectionsOverlayComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { origin: string; destination: string },
    private settingsService: SettingsService
  ) {}

  private getConfig(): Observable<string[]> {
    return this.settingsService.getSetting('directions');
  }
}
